import type { Organization } from '@/domain/organization'

// Seed organizations (Document 11 §4/§8 requirement: at least Demo School
// and Demo Enterprise, switchable to prove multi-tenancy before a real
// backend exists).
export const seedOrganizations: Organization[] = [
  {
    id: 'org-demo-school',
    name: 'Demo School',
    segment: 'school',
    hierarchy: [
      { id: 'dept-jss', name: 'Junior Secondary', parentId: null },
      { id: 'dept-sss', name: 'Senior Secondary', parentId: null },
    ],
    settings: { passingThresholdPercent: 80, leaderboardVisibility: true },
  },
  {
    id: 'org-demo-enterprise',
    name: 'Demo Enterprise',
    segment: 'enterprise',
    hierarchy: [
      { id: 'dept-ops', name: 'Operations', parentId: null },
      { id: 'dept-finance', name: 'Finance', parentId: null },
      { id: 'dept-it', name: 'IT & Security', parentId: null },
    ],
    settings: { passingThresholdPercent: 80, leaderboardVisibility: false },
  },
]
